import { matchUrls } from 'scripts/presentation/components/lib/linkify_it';
import { sanitizeHrefScheme } from 'components/text_editor_new/lib/serialize_html';

// Wraps bare URLs in an HTML string with <a> tags. URLs already inside an <a> are left untouched.
export default function linkifyHtml(html) {
  if (!html) return html;

  const doc = new DOMParser().parseFromString(html, 'text/html');
  const changed = linkifyChildren(doc, doc.body);

  // Only re-serialize (which would re-normalize the markup) when a link was actually added. Otherwise return
  // the input untouched, so an email with no linkifiable URL — including one whose only URLs live in href/src
  // attributes — is returned byte-for-byte.
  return changed ? doc.body.innerHTML : html;
}

function linkifyChildren(doc, element) {
  let changed = false;
  // Snapshot the child list — linkifyTextNode replaces nodes as we go.
  Array.from(element.childNodes).forEach(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      changed = linkifyTextNode(doc, node) || changed;
    } else if (node.nodeType === Node.ELEMENT_NODE && node.nodeName !== 'A') {
      // Never descend into an existing anchor — its URL is already linked.
      changed = linkifyChildren(doc, node) || changed;
    }
  });
  return changed;
}

function linkifyTextNode(doc, textNode) {
  const text = textNode.textContent;
  const matches = matchUrls(text);
  if (!matches.length) return false;

  const fragment = doc.createDocumentFragment();
  let cursor = 0;

  matches.forEach(match => {
    if (match.index > cursor) {
      fragment.appendChild(doc.createTextNode(text.slice(cursor, match.index)));
    }

    const anchor = doc.createElement('a');
    anchor.setAttribute('href', sanitizeHrefScheme(match.url));
    anchor.setAttribute('target', '_blank');
    anchor.setAttribute('rel', 'noopener noreferrer');
    anchor.textContent = match.text;
    fragment.appendChild(anchor);

    cursor = match.lastIndex;
  });

  if (cursor < text.length) {
    fragment.appendChild(doc.createTextNode(text.slice(cursor)));
  }

  textNode.parentNode.replaceChild(fragment, textNode);
  return true;
}
